import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <section className="section">
        <div className="container text-center">
          <h1 style={{ fontSize: '5rem', marginBottom: '20px' }}>404</h1>
          <h2>Page Not Found</h2>
          <p style={{ fontSize: '1.2rem', margin: '20px 0 30px' }}>
            The page you are looking for does not exist.
          </p>
          <Link to="/" className="btn btn-secondary">
            Go Back Home
          </Link>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
